import React, { FC } from "react";

import {
  Skeleton,
  SkeletonProps,
  SvgIconProps,
  Typography,
} from "@mui/material";
import styled from "@mui/material/styles/styled";

import RuiIconButton, { IconButtonProps } from "@rui/IconButton";
import RuiMenuItem from "@rui/MenuItem";
import Stack, { Row, StackProps } from "@rui/Stack";

type ContainerProps = StackProps & { isDefault: boolean; isEnabled: boolean };

export const Container = styled<FC<ContainerProps>>(
  ({ isDefault: _d, isEnabled: _e, ...props }) => <Stack {...props} />
)(({ isDefault, isEnabled, theme }) => ({
  border: "1px solid",
  borderColor: isDefault
    ? theme.palette.shades.primary[500]
    : theme.palette.shades.neutral[100],
  borderRadius: "6px",
  padding: theme.spacing(1.5),
  backgroundColor: isEnabled ? "#FFF" : "#FAFAFA",
}));

type ConstraintProps = StackProps & { Icon?: FC<SvgIconProps> };

export const Constraint = styled<FC<ConstraintProps>>(
  ({ Icon, children, ...props }) => (
    <Row variant="left" spacing={0.5} {...props}>
      {Icon && <Icon sx={{ fontSize: "12px", color: "inherit" }} />}
      <Typography variant="labelReg" lineHeight={1}>
        {children}
      </Typography>
    </Row>
  )
)(({ theme }) => ({
  minHeight: "14px",
  color: theme.palette.shades.neutral[500],
}));

export const IconButton = styled<FC<IconButtonProps>>(RuiIconButton)(
  ({ theme, variant }) => ({
    border:
      variant === "outlined"
        ? `1px solid ${theme.palette.shades.neutral[100]}`
        : "none",
    transition: "all 200ms ease",
    "& .MuiSvgIcon-root": {
      fontSize: "16px",
    },
    "&:hover": {
      borderColor:
        variant === "outlined" ? theme.palette.shades.primary[500] : undefined,
    },
  })
);

export const MenuItem = styled(RuiMenuItem)(({ theme }) => ({
  color: theme.palette.shades.neutral[500],
  padding: theme.spacing(0.75, 1),
}));

export const LoadingSchedulingLinkDetail = styled<FC<SkeletonProps>>(
  (props) => <Skeleton variant="rectangular" {...props} />
)({
  height: "84px",
  width: "100%",
  borderRadius: "6px",
});
